import React from 'react';
import Container from '../shared/Container';

interface Props {
	expiredDate: string;
}

const AssessmentExpired = ({ expiredDate }: Props) => {
	return (
		<Container className="flex items-center">
			<div className="flex max-w-[580px] mx-auto shadow-[0px_2px_4px_0px_rgba(0,0,0,0.12)] bg-[#FFF] rounded-[8px] justify-center">
				<div className="">
					<div className="max-w-[60px] max-h-[60px] mx-auto mt-[64px]">
						<img src="/assets/expired.svg" className="w-full h-full" alt="" />
					</div>
					<div className="flex flex-col justify-center items-center gap-[16px] py-[32px] px-[42px]">
						<p className="text-center font-inter text-[24px] font-[500] leading-[30px] text-[#7777E7]">
							Assessment Expired!
						</p>
						<p className="text-center font-inter text-[14px] font-medium leading-[20px] inline-block text-[#555770] px-[43px] pb-[60px] max-w-80">
							Sorry, the assessment ended on <strong>{expiredDate}</strong>.
						</p>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default AssessmentExpired;
